module.exports = __webpack_public_path__ + "static/media/cases_impressos_kelloggs_02a.b4af37f9.jpg";